import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/settings/billing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::index
* @see app/Http/Controllers/Settings/BillingController.php:15
* @route '/settings/billing'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Settings\BillingController::checkout
* @see app/Http/Controllers/Settings/BillingController.php:58
* @route '/settings/billing/checkout/{plan}'
*/
export const checkout = (args: { plan: string | number } | [plan: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkout.url(args, options),
    method: 'post',
})

checkout.definition = {
    methods: ["post"],
    url: '/settings/billing/checkout/{plan}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\BillingController::checkout
* @see app/Http/Controllers/Settings/BillingController.php:58
* @route '/settings/billing/checkout/{plan}'
*/
checkout.url = (args: { plan: string | number } | [plan: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { plan: args }
    }

    if (Array.isArray(args)) {
        args = {
            plan: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        plan: args.plan,
    }

    return checkout.definition.url
            .replace('{plan}', parsedArgs.plan.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\BillingController::checkout
* @see app/Http/Controllers/Settings/BillingController.php:58
* @route '/settings/billing/checkout/{plan}'
*/
checkout.post = (args: { plan: string | number } | [plan: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::checkout
* @see app/Http/Controllers/Settings/BillingController.php:58
* @route '/settings/billing/checkout/{plan}'
*/
const checkoutForm = (args: { plan: string | number } | [plan: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::checkout
* @see app/Http/Controllers/Settings/BillingController.php:58
* @route '/settings/billing/checkout/{plan}'
*/
checkoutForm.post = (args: { plan: string | number } | [plan: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkout.url(args, options),
    method: 'post',
})

checkout.form = checkoutForm

/**
* @see \App\Http\Controllers\Settings\BillingController::portal
* @see app/Http/Controllers/Settings/BillingController.php:107
* @route '/settings/billing/portal'
*/
export const portal = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: portal.url(options),
    method: 'post',
})

portal.definition = {
    methods: ["post"],
    url: '/settings/billing/portal',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\BillingController::portal
* @see app/Http/Controllers/Settings/BillingController.php:107
* @route '/settings/billing/portal'
*/
portal.url = (options?: RouteQueryOptions) => {
    return portal.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\BillingController::portal
* @see app/Http/Controllers/Settings/BillingController.php:107
* @route '/settings/billing/portal'
*/
portal.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: portal.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::portal
* @see app/Http/Controllers/Settings/BillingController.php:107
* @route '/settings/billing/portal'
*/
const portalForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: portal.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\BillingController::portal
* @see app/Http/Controllers/Settings/BillingController.php:107
* @route '/settings/billing/portal'
*/
portalForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: portal.url(options),
    method: 'post',
})

portal.form = portalForm

const billing = {
    index: Object.assign(index, index),
    checkout: Object.assign(checkout, checkout),
    portal: Object.assign(portal, portal),
}

export default billing